module.exports = __webpack_public_path__ + "img/package.27529aca.svg";